import { KitcenSinkRow, KitchenSinkRowItem } from 'store-types';

type Row = KitcenSinkRow | KitchenSinkRowItem;

export const isPromoRow = (row?: Row): boolean => {
  // TODO: Should consider changing this to check the layout type
  // as opposed to the first item (CSVSTV-377)
  if (row && typeof row === 'object' && 'data' in row && row.data) {
    return row.data[0]?.type === 'PROMO';
  }
  return false;
};

export const isRowWithScoring = (row: Row): boolean => {
  return row.slug === 'highlights';
};

const TRENDING_ROW_LAYOUTS = [
  'threeAcrossTopTrending',
  'fourAcrossTopTrending',
  'fiveAcrossTopTrending',
];

export const TRENDING_ROW_MAX_ITEMS = 15;

export const isTrendingRow = (row: Row): boolean => {
  const layout = (row as KitchenSinkRowItem)?.layout;
  return !!layout && TRENDING_ROW_LAYOUTS.includes(layout as string);
};
